import moment from "moment-timezone";

export const START_DAY_OF_A_MONTH = moment().startOf("month").toDate();
export const END_DAY_OF_A_MONTH = moment().endOf("month").toDate();

export const defaultMaxHoursSick = 0;
export const defaultMaxHoursMiss = 0;
export const defaultMaxHoursHoliday = 0;

//CONSTANTS UTILE POUR LE CONGE
export const MALADIE = "Maladie";
export const ABSENCE = "Absence";
export const VACANCE = "Vacances";

export const minCongeHours = 1;
export const minWorkingHoursMinutes = 1; //Valeur minimal d'horaire travaillée autorisée en minute
export const minAgendaMinutes = 1; //Valeur minimal d'horaire prévue autorisée en minute

export const defaultStartHour = "07:30";
export const defaultEndHour = "23:30";

export const defaultHourFormat = "hh:mm A";

export const REFERENCE_PERIODS = [
  // startDay: 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday, 7 = Sunday
  {
    _id: "sunday_to_saturday",
    name: "Dimanche au samedi",
    label: "Dimanche au samedi",
    startDay: 7,
    durationInWeeks: 1
  },
  {
    _id: "sunday_to_saturday_2_weeks",
    name: "Dimanche au samedi (2 semaines)",
    label: "Dimanche au samedi (2 semaines)",
    startDay: 7,
    durationInWeeks: 2
  },
  {
    _id: "monday_to_sunday",
    name: "Lundi au dimanche",
    label: "Lundi au dimanche",
    startDay: 1,
    durationInWeeks: 1
  },
  {
    _id: "monday_to_sunday_2_weeks",
    name: "Lundi au dimanche (2 semaines)",
    label: "Lundi au dimanche (2 semaines)",
    startDay: 1,
    durationInWeeks: 2
  },
  {
    _id: "tuesday_to_monday",
    name: "Mardi au lundi",
    label: "Mardi au lundi",
    startDay: 2,
    durationInWeeks: 1
  },
  {
    _id: "tuesday_to_monday_2_weeks",
    name: "Mardi au lundi (2 semaines)",
    label: "Mardi au lundi (2 semaines)",
    startDay: 2,
    durationInWeeks: 2
  },
  {
    _id: "wednesday_to_tuesday",
    name: "Mercredi au mardi",
    label: "Mercredi au mardi",
    startDay: 3,
    durationInWeeks: 1
  },
  {
    _id: "wednesday_to_tuesday_2_weeks",
    name: "Mercredi au mardi (2 semaines)",
    label: "Mercredi au mardi (2 semaines)",
    startDay: 3,
    durationInWeeks: 2
  },
  {
    _id: "thursday_to_wednesday",
    name: "Jeudi au mercredi",
    label: "Jeudi au mercredi",
    startDay: 4,
    durationInWeeks: 1
  },
  {
    _id: "thursday_to_wednesday_2_weeks",
    name: "Jeudi au mercredi (2 semaines)",
    label: "Jeudi au mercredi (2 semaines)",
    startDay: 4,
    durationInWeeks: 2
  },
  {
    _id: "friday_to_thursday",
    name: "Vendredi au Jeudi",
    label: "Vendredi au Jeudi",
    startDay: 5,
    durationInWeeks: 1
  },
  {
    _id: "friday_to_thursday_2_weeks",
    name: "Vendredi au Jeudi (2 semaines)",
    label: "Vendredi au Jeudi (2 semaines)",
    startDay: 5,
    durationInWeeks: 2
  },
  {
    _id: "saturday_to_friday",
    name: "Samedi au vendredi",
    label: "Samedi au vendredi",
    startDay: 6,
    durationInWeeks: 1
  },
  {
    _id: "saturday_to_friday_2_weeks",
    name: "Samedi au vendredi (2 semaines)",
    label: "Samedi au vendredi (2 semaines)",
    startDay: 6,
    durationInWeeks: 2
  }
];

export const maFicheEmploye = "ma-fiche-employe";
export const addEmployer = "ajout-employe";

export const dossierEmployes = "dossiers-employes";
export const employeDocumentation = "employe-documentation";
export const entrepriseDocumentation = "entreprise-documentation";

export const defaultImageUrl = "https://cdn.pixabay.com/";
// export const serverUri = (window.location.href.includes("local"))? "http://localhost:8080" : (window.location.href.includes("dev2020"))? "https://dev2020.altee.com/api/" : "https://app.altee.com/api/";
export const serverUri = process.env.REACT_APP_SERVER_URI;

export const congeCategoriesPossibleValue = ["Absence", "Vacances", "Maladie"];
// export const congeStatusPossibleValues = ["en attente", "Acceptée", "Refusée"];
export const defaultRemainingDayValue = "-";

export const defaultUserImage =
  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";

export const BASE_COLOR = {
  firstColor: "#fcb698",
  secondColor: "#fa966b",
  loaderBlue: "#4472a3",
  loaderGreen: "#73c7b7",
  loaderParams: "#1a4e63"
};

export const GRAPH_CONF = {
  defaultBorderColor: "#d4d3d2",
  maxLabelLength: 40
};

export const MAX_ANNUAL_SALARY = 99999999;

export const TAILWIND_RESPONSIVE = {
  "2xl": 1536,
  "xl": 1280,
  "lg": 1024
};

export const MONTH_STR_EN = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];
export const MONTH_STR_FR = [
  "Janv",
  "Févr",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juil",
  "Août",
  "Sept",
  "Oct",
  "Nov",
  "Déc"
];

export const DATE_STR_FORMAT = {
  fr: "LL",
  en: "LL"
};
export const INIT_EVOLUTION = [
  moment().subtract(5, "years").get("year"),
  moment().get("year")
];
export const LOGO_ALTEE =
  "https://uploads-ssl.webflow.com/639b7bb3508f5536915f80c0/639b843e4fb1b00671141455_Logo.svg";
//status post
export const STATUS_FINISHED = "INACTIF";
// Model name constants
export const MODEL_NAME_EMPLOI_CERTIFICATION = "EmploiCertifications";
export const MODEL_NAME_EMPLOI_FORMATION = "EmploiFormation";
export const MODEL_NAME_CONGE = "Conge";
export const MODEL_NAME_NEW_FOLDER = "Employer";
export const MODEL_NAME_ENTERPRISE = "Entreprise";
export const MODEL_NAME_WORKING_HOUR_POINTING = "WorkingHour";
export const MODEL_NAME_USER_EXTERNAL = "UserExternal";
export const MODEL_NAME_MATERIAL = "Material";
export const MODEL_NAME_EMPLOI_DISCIPLINNARY = "EmploiDisciplinary";

export const PERMISSION_ADMIN = "Administrateur";
export const PERMISSION_SUPER_ADMIN = "Super-Administrateur (Modèle Altee)";
export const PERMISSION_EMPLOYEE = "Employés (Modèle Altee)";
export const PERMISSION_MANAGER = "Gestionnaires (Modèle Altee)";
export const PERMISSION_ACCOUNTING = "Comptabilité (Modèle Altee)";
export const ROLE_ADMIN = "admin";
export const ROLE_EMPLOYER = "employer";

// Congé status
export const CONGE_STATUS_APPROUVED = "Acceptée";
export const CONGE_STATUS_REFUSED = "Refusée";
export const CONGE_STATUS_PRE_APPROUVED = "Pré-approuvée";

// Socket variables
export const SOCKET_TOGGLE_TIMECLOCK = "toggleTimeClock";
export const SOCKET_TOGGLE_ACTIVE_TIMECLOCK = "toggleActiveTimeClock";

// Socket variables for notification
export const SOCKET_NEW_NOTIFICATION = "newNotification";
export const SOCKET_LOGIN = "login";
export const SOCKET_NEWS = "news";
export const SOCKET_ON_NEW_NOTIFICATION = "onNewNotification";
export const RELOAD_NOTIFICATION = "reload_notification";
// Notification type
export const NOTIFICATION_TYPE_ENTERPRISE = "Entreprise";
export const NOTIFICATION_TYPE_USER = "Users";

// Notification constants
export const NOTIFICATION_NEWS = "News";
export const NOTIFICATION_COMMENT = "Comment";
export const NOTIFICATION_CONGE = "Conge";
export const NOTIFICATION_AGENDA = "Agenda";
export const NOTIFICAITON_NEWS_LIKE = "NewsLike";
export const NOTIFICATION_NEWS_COMMENT = "NewsComment";
export const NOTIFICATION_NEWS_VISIBILITY = "NewsVisibility";
export const NOTIFICATION_NEWS_VUE = "NewsVue";
export const NOTIFICATION_WORKING_HOUR = "WorkingHour";
export const NOTIFICATION_DOCUMENT_STORAGE = "DocumentStorage";
export const NOTIFICATION_EMPLOIE_CERTIFICATION = "EmploiCertifications";
export const NOTIFICATION_EMPLOIE_COURSE = "EmploiCourses";
export const NOTIFICATION_EMPLOIE_FORMATION = "EmploiFormation";
export const NOTIFICATION_EMPLOIE_DISCIPLINARY = "EmploiDisciplinary";
export const NOTIFICATION_HORAIRE = "Agenda";
export const MODEL_CANDIDATE = "UserExternal";
export const NOTIFICATION_ONBOARDING_EMPLOYE_TASK = "OnboardingEmployeTask";
export const MODEL_REIMBURSEMENT = "Reimbursement";
export const NOTIFICATION_EMPLOYEE_FILE_UPDATE = "EmployeeFileUpdate";

export const TIMEBANK_SOCKET = "refresh_timebank";

export const NOTIFICATION_MSG_EXCEP = [
  "your_candidate",
  "onboarding_task_overdue_task",
  "onboarding_task_warning_2day_before",
  "onboarding_task_reminding",
  "assignement_onboarding_task",
  "evaluation_todo",
  "evaluation_todo_late",
  "survey_todo",
  "survey_todo_late",
  "task_canceled",
  "task_performed"
];

export const REGEX_VALID_DECIMAL_NUMBER = /^\d+(\.\d+)?/;
export const VALID_DATE =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
export const REGEX_TIME = /^((1[0-2])|[1-9]):[0-5][0-9]\s(AM|PM)$/;
export const REGEX_TIME_TYPE =
  /^([1-9]|1?[0-2])?(^([1-9]|1?[0-2])?:)?(^((1?[0-2]|[1-9])?:)([0-9]|[0-5][0-9]))?(^((1?[0-2]|[1-9])?:?[0-5]?[0-9]?)?\s)?(^(((1?[0-2]|[1-9])?:?[0-5]?[0-9]?)?\s?)?(A|P|M|AM|PM))?$/;
//Regex
export const REGEX_NAME = /^(?![\s.]+$)[a-zA-Zéàçèôôöêëûüîïœ\-\s.]*$/;
// export const REGEX_PHONE = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export const REGEX_PHONE =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
export const REGEX_PHONE2 =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
export const REGEX_PHONE_INVERSE = /(?!(-|\+))[^0-9.]/g;
// export const REGEX_EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const REGEX_EMAIL =
  /^[\w\áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ+-]+([\.]?[\w\áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ-]+)*@\w+([\.-]?\w+)*(\.\w{2,20})+$/;
export const REGEX_ALL_IMAGE =
  /\.(3fr|arw|avif|bmp|cr2|crw|cur|dcm|dcr|dds|dng|erf|exr|fax|fts|g3|g4|gif|gv|hdr|heic|heif|hrz|ico|iiq|ipl|jbg|jbig|jfi|jfif|jif|jnx|jp2|jpe|jpeg|jpg|jps|k25|kdc|mac|map|mef|mng|mrw|mtv|nef|nrw|orf|otb|pal|palm|pam|pbm|pcd|pct|pcx|pdb|pef|pes|pfm|pgm|pgx|picon|pict|pix|plasma|png|pnm|ppm|psd|pwp|raf|ras|rgb|rgba|rgbo|rgf|rla|rle|rw2|sct|sfw|sgi|six|sixel|sr2|srf|sun|svg|tga|tiff|tim|tm2|uyvy|viff|vips|wbmp|webp|wmz|wpg|x3f|xbm|xc|xcf|xpm|xv|xwd|yuv|3FR|ARW|AVIF|BMP|CR2|CRW|CUR|DCM|DCR|DDS|DNG|ERF|EXR|FAX|FTS|G3|G4|GIF|GV|HDR|HEIC|HEIF|HRZ|ICO|IIQ|IPL|JBG|JBIG|JFI|JFIF|JIF|JNX|JP2|JPE|JPEG|JPG|JPS|K25|KDC|MAC|MAP|MEF|MNG|MRW|MTV|NEF|NRW|ORF|OTB|PAL|PALM|PAM|PBM|PCD|PCT|PCX|PDB|PEF|PES|PFM|PGM|PGX|PICON|PICT|PIX|PLASMA|PNG|PNM|PPM|PSD|PWP|RAF|RAS|RGB|RGBA|RGBO|RGF|RLA|RLE|RW2|SCT|SFW|SGI|SIX|SIXEL|SR2|SRF|SUN|SVG|TGA|TIFF|TIM|TM2|UYVY|VIFF|VIPS|WBMP|WEBP|WMZ|WPG|X3F|XBM|XC|XCF|XPM|XV|XWD|YUV)$/;
export const REGEX_VALID_FILES =
  /\.(jpg|jpeg|png|gif|bmp|webp|ico|JPG|JPEG|PNG|GIF|BMP|WEBP|ICO|pdf|PDF|doc|DOC|csv|xslx|docx|mp4|webm|mp3|CSV|XSLX|DOCX|MP4|WEBM|MP3|msg|MSG)$/;
export const REGEX_NOT_NUMBER = /(?!(\.))[^0-9.]/g;
export const REGEX_NUMBER = /^\d+$/g;
export const HEXADECIMAL_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
export const RGBA_REGEX = /^rgb\s*\(((\d{1,3}),\s*){2,3}((\d{1,3})\))$/i;
export const REGEX_LINK =
  /^(?:http(s)?:\/\/)?[\w\.\-]+(?:\.[\w\.\-]+)+[\w\-\._~:/?#\[\]@!\$&'\(\)\*\+,;=.]+$/;
export const REGEX_CHECK_LINKS =
  /(https?:\/\/)[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w]*)?(\?[^\s]*)?/gi;
export const REGEX_VALID_DOMAIN_NAME =
  /^[a-z0-9]+(?:[\-.][a-z0-9]+)*\.[a-z]{2,6}$/i; ///^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/
export const STRONG_PASSWORD_REGEX = new RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})"
);
export const REGEX_POST_NUMBER = /^[0-9]{3,6}$/;
export const REGEX_TRANSIT_NUMBER = /^[0-9]{5}$/;
export const REGEX_ACCOUNT_NUMBER = /^\d{7,12}$/;
export const REGEX_SOCIAL_NUMBER = /^[0-9]{9}$/;
export const REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER =
  /^[a-zA-Z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/~`|-]+$/;
export const IMAGE_TYPE_FILES = ".jpg,.jpeg,.png,.gif,.bmp,.webp,.ico,.jfif";
export const VALID_TYPE_FILES =
  ".jpg,.jpeg,.png,.gif,.bmp,.webp,.ico,.pdf,.doc,.csv,.xslx,.docx,.mp4,.webm,.mp3,.msg,.xlsx,.jfif";
export const VIDEO_TYPE_FILES =
  ".avi,.mp4,.mkv,.mov,.wmv,.flv,.webm,.mpeg,.mpg,.3gp,.ogv',.m4v,.mts,.m2ts,.ts,.divx,.xvid";
// par absurde
export const INVALID_TYPE_FILES =
  " .php , .js , .exe , .crx , .json , .sql .jsx  ";

export const NUMBER_ONLY = /\D/g;
export const FLOAT_ONLY = /[^0-9.]/g;
//file type in file manager
export const FileType = { file: "file", folder: "folder" };

export const PATTERN_FILENAME = /^[^<>:"\/\\|?*\x00-\x1F]+$/;
export const REGEX_FILENAME = /^[0-9a-z_\-]{3,255}\.([a-z0-9]{2,5})$/;

//constants for socket
export const CONSTANT_SOCKET_FOR_EMPLOYEURD = "reload_employeurD";
export const CONSTANT_SOCKET_FOR_USER = "reload_user";
export const CONSTANT_SOCKET_FOR_EMPLOYEE = "reload_employe";
export const CONSTANT_SOCKET_FOR_EMPLOYEE_AND_SALARY =
  "reload_employe_and_salary";
export const RELOAD_ADVANTAGE_TYPE = "reload_advantage_type";
export const RELOAD_ADDITIONAL_INFORMATION = "reload_additional_information";
export const RELOAD_GENDER_TYPE = "reload_gender_type";
export const CONSTANT_SOCKET_FOR_DROPDOWN_HIERARCHICAL_IN_EMPLOYEE_AND_SALARY_ONLY =
  "reload_dropdown_in_employee_and_salary";
export const CONSTANT_SOCKET_FOR_ACCESS_PROFILE = "reload_access_profile";
export const CONSTANT_SOCKET_FOR_PLANNED_HOURS = "reload_planned_hours";
export const CONSTANT_SOCKET_FOR_CONGES = "reload_conges";
export const CONSTANT_SOCKET_FOR_EMPLOYER_HOURS = "reload_employer_hours";
export const CONSTANT_SOCKET_FOR_WORKING_HOURS = "reload_working_hours";
export const CONSTANT_SOCKET_FOR_TIMECLOCK_LIMIT = "timeClockLimitUpdate";
export const CONSTANT_SOCKET_FOR_TIMECLOCK = "reload_timeclock";
export const CONSTANT_SOCKET_FOR_PERMISSION = "reload_permission";
export const CONSTANT_SOCKET_FOR_POSTE = "reload_poste";
export const CONSTANT_SOCKET_FOR_GROUPS = "reload_group";
export const CONSTANT_SOCKET_FOR_EMPLACEMENT = "reload_emplacement";
export const CONSTANT_SOCKET_FOR_ENTERPRISE = "reload_enterprise";
export const CONSTANT_SOCKET_FOR_NEWS = "reload_news";
export const CONSTANT_SOCKET_FOR_NOTE = "reload_note";
export const CONSTANT_SOCKET_FOR_NOTE_RH = "reload_note_rh";
export const CONSTANT_SOCKET_FOR_COURSE = "reload_course";
export const CONSTANT_SOCKET_FOR_CERTIFICATION = "reload_certification";
export const CONSTANT_SOCKET_FOR_FORMATION = "reload_emploi_formation";
export const CONSTANT_SOCKET_FOR_DOCUMENTS_STORAGES = "reload_files";
export const CONSTANT_SOCKET_FOR_DEFAULT_FOLDERS = "reload_default_folders";
export const SOCKET_DOCUMENTS_STORAGE_EMPLOYEE = "reload_document_storage";
export const RELOAD_HIRING_ANNIVERSARY = "reload_hiring_anniversary";
export const CONSTANT_SOCKET_FOR_MATERIAL = "reload_material";
export const RELOAD_ASSIGNEMENT = "reload_assignement";
export const JOB_EVENT = "reload_job";
export const DAY_OFF_EVENT = "reload_day_off";
export const CONSTANT_SOCKET_BULLES = "reload_bulles";
export const CONSTANT_SOCKET_TAGS = "reload_tags";
export const CONSTANT_SOCKET_APPLICATION = "reload_application";
export const RELOAD_CV_BANK = "reload_cv_bank";
export const RELOAD_PROTOCOL = "reload_protocol";
export const RELOAD_EMPLOYE_PROTOCOL = "reload_employe_protocol";
export const RELOAD_EMPLOYE_TASK = "reload_employe_task";
export const RELOAD_EMPLOYE_FLOW = "reload_unavailability";
export const RELOAD_STATS = "reload_stats";
export const RELOAD_REFUSAL_REASONS = "reload_refusal_reasons";
export const RELOAD_APPLICATION_SOURCES = "reload_application_sources";
export const RELOAD_EXPENSES = "reload_expenses";
export const RELOAD_ITINERARY = "reload_itinerary";
export const RELOAD_REIMBURSEMENT = "reload_reimbursment";
export const RELOAD_REIMBURSEMENT_LISTS = "reload_reimbursment_lists";
export const RELOAD_PIPELINE_TEMPLATE = "reload_pipeline_model";
export const RELOAD_FORM_TEMPLATE = "reload_application_form";
export const RELOAD_EMAIL_TEMPLATE = "reload_email_template";
export const RELOAD_POST_TEAM = "reload_post_team";
export const RELOAD_POST_LOCATION = "reload_post_location";
export const RELOAD_JOB_PIPELINE = "reload_job_pipeline";
export const RELOAD_EVALUATION = "reload_evaluation";
export const RELOAD_QUESTION = "reload_question";
export const RELOAD_EVALUATION_REQUEST = "reload_evaluation_request";
export const RELOAD_EVALUATION_REQUEST_TEMPLATE =
  "reload_evaluation_request_template";
export const RELOAD_EVALUATION_ALERT = "reload_evaluation_alert";
export const RELOAD_DOCUMENTATION = "reload_documentation";
export const JOBBOARD_DATA_EVENT = "reload_jobboard_data";
export const RELOAD_ORGANIGRAM = "reload_organigram";
export const RELOAD_EVALUATION_NOTE = "reload_evaluation_note";
export const RELOAD_WORKED_HOURS_TYPES = "reload_workedHoursTypes";
export const RELOAD_EVALUATION_OBJECTIVE = "reload_evaluation_objective";
export const RELOAD_EVALUATION_NOTATION = "reload_evaluation_notation";
export const RELOAD_TYPE_DEMISSION = "reload_demission";
export const RELOAD_HEALTH = "reload_emploiHealth";
export const RELOAD_CLOTHES = "reload_emploiClothes";
export const RELOAD_INDIVIDUAL_OBJECTIVE = "reload_individual_objective";
export const RELOAD_INDIVIDUAL_OBJECTIVE_TYPE =
  "reload_individual_objective_type";
export const RELOAD_OBJECTIVE_PERIOD = "reload_objective_period";
export const RELOAD_USER_CONNECTED_ONLY = "reload_user_connected_only";
export const RELOAD_EXTERNAL_LINKS = "reload_external_links";
export const RELOAD_ORGANISATOR_PROJECT = "reload_organisator_project";
export const HOLIDAY_NAME_SOCKET = "refresh_holiday_name";
export const RELOAD_PRIMES = "reload_primes";
export const RELOAD_COEFFICIENT_MULTIPLIER = "reload_coefficientMultiplier";
export const RELOAD_STATUS = "reload_status";
export const RELOAD_EMPLOYER_STATUS = "reload_employer_status";
export const RELOAD_PERMISSION_NOTE_RH = "reload_permission_note_rh";
export const RELOAD_INSURANCE_COVERAGE = "reload_insuranceCoverage";
export const RELOAD_DISCIPLINARY_CATEGORY = "reload_disciplinaryCategory";
export const RELOAD_DISCIPLINARY_GRADATION = "reload_disciplinaryGradation";
export const RELOAD_DISCIPLINARY = "reload_disciplinary";
export const RELOAD_AGENDA_MODEL = "reload_agenda_model";
export const RELOAD_DOCUMENT_TEMPLATES = "reload_document_template";
export const RELOAD_IMPLANTATION_MODULE = "reload_implantation_module";
export const RELOAD_SURVEY_TYPE = "reload_survey_type";
export const RELOAD_SURVEY_SUBJECT_GROUP = "reload_survey_subject_group";
export const RELOAD_SURVEY_QUESTION = "reload_survey_question";
export const RELOAD_SURVEY_REQUEST_TEMPLATE = "reload_survey_request_template";
export const RELOAD_SURVEY_REQUEST = "reload_survey_request";
export const RELOAD_SURVEY_ALERT = "reload_survey_alert";
export const RELOAD_SURVEY_OBJECTIVE = "reload_survey_objective";
export const RELOAD_SALARY_TEMPLATE = "reload_salary_template";
export const REFRESH_REQUIRED_FLAGS = "refresh_required_flags";

//constants size of file uploaded
export const MAX_SIZE_FOR_INPUTFILE_IN_MODAL_CERTIFICATION = 40485760; // 40 Mo
// export const MAX_SIZE_FOR_FILE_MANAGER = 314572800; // 300 Mo
//Illimite
export const ILLIMITE = "Illimité";

//AGE MINIMUM
export const AGE_MINIMUM = 15;
//STATUS
export const ACTIF = "Actif";
export const TEMPORAIREMENT_INACTIF = "Inactif Temporairement";
export const DEFINITIVEMENT_INACTIF = "Inactif Définitivement";
//ERROR
export const ERROR = "error";
//MESSAGE
export const MSG_INVALID_FILE_TYPE =
  "Veuillez sélectionner un type de fichier valide.";
export const MESSAGE_DE_VALIDATION_SI_L_EMAIL_EXISTE_DEJA =
  "Le courrier existe déjà";
export const MESSAGE_D_ERREUR_DE_VERIFICATION_D_EMAIL =
  "Erreur de vérification de l'email";
export const MESSAGE_DE_VALIDATION_S_IL_Y_A_DES_ERREURS_A_PART_LES_CHAMPS_REQUIS =
  "Veuillez regler l(es) erreur(s)!";
export const MESSAGE_DE_VALIDATION_POUR_LES_CHAMPS_REQUIS =
  "Pour pouvoir enregistrer, les champs dotés d'un astérisque doivent être remplis";
export const MESSAGE_FOR_EMPLOYEE_INACTIVE_DEFINITELY_PART_1 =
  "La modification du statut a été enregistrée à la date d'aujourd'hui";
export const MESSAGE_FOR_EMPLOYEE_INACTIVE_DEFINITELY_PART_2 =
  "Cette date est modifiable dans le menu 'parcours et certifications'";
export const MESSAGE_FOR_HIRING_DATE_AFTER_DATE_OF_BIRTH =
  "La date d'embauche doit être supérieure à la date de naissance";
export const MESSAGE_FOR_DATE_OF_CREATION_OF_THE_ENTERPRISE_AFTER_HIRING_DATE =
  "La date d'embauche doit être supérieure à la date de création de l'entreprise";
export const MESSAGE_TO_INFROM_USER_THE_PRIORITY =
  "Veuillez remplir les informations personnelles et emploi et salaires avant de remplir les autres onglets";
//IMAGES
export const BLANK_PROFILE_PICTURE =
  "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";

//Number of item per page after first requestexport
export const ITEM_PER_PAGE = 10;

// reajustement of component below the scroll
export const LEEWAY_SIZE = 100;
export const PADDING_BOTTOM = 9;

//variable for recruitments
export const PIPELINE = "pipelines";
export const AVAILABLE_POSTES = "availablePostes";
export const CANDIDATES = "candidates";
export const RECRUITS = "applications";
export const CV_BANK = "cvBank";
export const EMAILS = "emails";
export const CARREER_PAGE = "careerPage";
export const MODELE = "modele";
export const STATISTICS = "statistics";

//Variable for documentations
export const DOCUMENTS = "documents";
export const ORGANIGRAMME = "organigramme";

export const DOCUMENTS_EMPLOYEE = "DDocumentation";
export const ORGANIGRAMME_EMPLOYEE = "DOrganigram";

// NUMBER CHARACTER
export const NUMBER_CHARACTER = 60;
// type of message of recruitments
export const RECRUITE_CANDIDATE = "recruit candidate";
export const REJECTED_CANDIDATE = "rejected candidate";
export const CANDIDATE_PASSED_TO_NEXT_STEEP = "recruit candidate";
export const SUCCESS_ACTION = "success";
export const WARNING_ACTION = "warning";
export const INFO_ACTION = "info";
// opacity value for card's pipeline
export const OPACITY_FOR_BORDER_TOP_BACKGROUND = 0.9;
export const OPACITY_COLOR_FONT_FOR_BADGE = 1;
export const OPACITY_BACKGROUND_FOR_BADGE = 0.5;

export const ANNIVERSARY_BIRTH_TYPE = "birth";
export const ANNIVERSARY_HIRING_TYPE = "hiring";

export const ATTRIBUTION_TYPE_EMPLOYER = "Employer";
export const ATTRIBUTION_TYPE_GROUPE = "Groupe";
export const ATTRIBUTION_TYPE_EMPLACEMENT = "Emplacement";
// constants for material
export const DATE_AQUISITION_TYPE = [
  { _id: "dateWarranty", title: "Fin de garantie" },
  { _id: "dateContrat", title: "Terme du contrat" },
  { _id: "attributionDate", title: "Assigné le" }
];

export const STATE_MATERIAL = [
  { _id: "neuf", title: "Neuf" },
  { _id: "usage", title: "Usagé" },
  { _id: "endommage", title: "Endommagé" },
  { _id: "nonFonctionnel", title: "Non-fonctionnel" }
];
export const STATUS_MATERIAL = [
  { _id: "libre", title: "Libre", color: "actif" },
  { _id: "assigne", title: "Assigné", color: "blue" },
  {
    _id: "assignAndSecurity",
    title: "Assigné & sécurisé",
    color: "darkRoyalBlue"
  },
  { _id: "reserve", title: "Reservé/en attente", color: "yellow" },
  { _id: "indisponible", title: "Indisponible temporairement", color: "red" },
  { _id: "perdu", title: "Perdu/volé", color: "purple" },
  { _id: "retire", title: "Retiré de l'inventaire", color: "inactive" }
];

export const CATEGORY_MATERIAL = [
  { _id: "ordinateur", title: "Ordinateur" },
  { _id: "telephone", title: "Téléphone" },
  { _id: "matElec", title: "Matériel électronique" },
  { _id: "matInfo", title: "Matériel informatique" },
  { _id: "matResequ", title: "Matériel d'infrastructure réseau" },

  { _id: "matProtection", title: "Equipement de protection" },
  { _id: "matPersonne", title: "Equipement de la personne" },
  { _id: "vetementEtAccessoire", title: "Vêtements et accessoires" },

  { _id: "vehicule", title: "Véhicule" },
  { _id: "autreVehicule", title: "Autres équipement motorisés" },

  { _id: "mobilier", title: "Mobilier/Agencement" },
  { _id: "matBureau", title: "Equipement de bureau" },

  { _id: "machine", title: "Machines et équipements" },
  { _id: "outillage", title: "Matériel et outillage" },
  { _id: "cartesAcce", title: "Clés et cartes d'accès" }
];

export const DECLARATION_DES_HEURES = "Déclaration des heures";
export const POINTAGE_SANS_PHOTO = "Pointage sans photo";
export const POINTAGE_AVEC_PHOTO = "Pointage avec photo";
export const AUCUN = "Aucun";
export const DECLARATION_POINTAGE = "Déclaration/pointage";
export const ENREGISTREMENT_DES_BLOCS_D_HEURES =
  "Enregistrement de blocs d'heures";
export const ENREGISTREMENT_DES_BLOCS_D_HEURES_MULTIPLE =
  "Enregistrements multiples des heures";
export const ENREGISTREMENT_DES_HEURES_PAR_PROJET =
  "Enregistrements des heures par projets";
// Days off
export const PUBLIC_HOLIDAY = "Journée férié";
export const SPECIAL_DAY = "Journée spéciale";
export const KEY_SPECIAL_DAY = "speciale";
export const KEY_PUBLIC_HOLIDAY = "holidays";
export const TAB_RECAPITULATIF_MENSUEL = "recapitulatifMensuel";
export const TAB_REPARTITION = "repartition";
export const TAB_COMPTE_RENDU = "compteRendu";
export const TAB_POINTAGE = "saisieDesHeuresEtPointage";

// Constante pour le custom domain
export const IP_SERVER = process.env.REACT_APP_IP_SERVER;
export const CD_STATUS_CONNECTED = "CONNECTED";
export const CD_STATUS_NOT_CONNTECTED = "NOT_CONNECTED";
export const CD_INSTALLED_SSL = "INSTALLED";
export const CD_NOT_INSTALLED_SSL = "NOT_INSTALLED";
export const CD_STATUS_CREATE_SUCCESS = "SUCCESS";

// Possible value of user data access :
export const DIRECT_SUBORDINATES = "DirectSub";
export const SUBORDINATE_EMPLOYERS = "SubEmployers";
export const SUBORDINATE_AND_SIBLINGS = "SubAndSiblings";
export const ALL_EMPLOYERS = "All";
export const CUSTOMIZED = "CUSTOMIZED";

export const CALL_OUT_MESSAGE_DURATION = 3000;

export const WAITING = "En attente";
export const ACCEPTED = "Acceptée";
export const REFUSED = "Refusée";
export const PRE_APPROVED = "Pré-approuvée";
export const UNAVAILABILITY = "unavailability";

//Notification type
export const TYPE_ETIQUETTE = "Etiquette";
export const TYPE_MODAL = "Modal";
export const TYPE_PAGE = "Page";

export const TOOLTIP_SALARY = "TOOLTIP_SALARY";
export const TOOLTIP_COURSE = "TOOLTIP_COURSE";
export const TOOLTIP_MATERIAL = "TOOLTIP_MATERIAL";

export const PIPELINES_DEFAULT_TITLES = [
  "Pipeline à 2 étapes",
  "Pipeline à 3 étapes",
  "Pipeline à 4 étapes",
  "Pipeline à 5 étapes",
  "Pipeline à 6 étapes",
  "Pipeline à 7 étapes",
  "Pipeline à 8 étapes"
];

export const MODELE_RESSOURCE = "pages.recruitments.modele";
export const COUNTRY_RESSOURCE = "components.dropdown.dropdownCountry";

export const EMPLOYEES_LIST_PERMISSION = "listBuild";

export const GOOGLE_CLIENT_ID =
  "438513092038-27an1o3uubqmsq59pcine14ibkdjj3cv.apps.googleusercontent.com";
export const MICROSOFT_CLIENT_ID = "1aec4b7b-ad84-46c3-948e-9425cfead05e";
export const DOSSIER_EMPLOYER = "/admin/dossiers-employes/";

//News constant
export const MIME_TYPE = ["mp4", "MP4", "mpeg4", "MPGE4"];
export const FILE_TYPE = ["audio", "image", "application"];

//Report constant
export const initReportFilters = {
  startDate: moment()
    .startOf("month")
    .set({ hour: 0, minute: 0, second: 0 })
    .toDate(),
  endDate: moment()
    .endOf("month")
    .set({ hour: 23, minute: 59, second: 59 })
    .toDate()
};

export const statusColors = {
  reimbursed: "arh-bg-[#4472A3]",
  refused: "arh-bg-[#f67c53]",
  accepted: "arh-bg-[#92e98f]",
  accounted: "arh-bg-[#37a1eb]",
  preApproved: "arh-bg-[#B494FD]"
};

export const initMonthFilters = {
  startDate: moment()
    .startOf("month")
    .set({ hour: 0, minute: 0, second: 0 })
    .toDate(),
  endDate: moment()
    .endOf("month")
    .set({ hour: 23, minute: 59, second: 59 })
    .toDate()
};

export const NEWSFILE_RECOGNISED_MIMETYPES = [
  "text/css",
  "text/csv",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/gzip",
  "text/html",
  "text/calendar",
  "text/javascript",
  "application/json",
  "application/ld+json",
  "text/plain",
  "application/xml",
  "application/vnd.ms-excel",
  "application/xhtml+xml",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip",
  "application/pdf",
  "application/x-httpd-php",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.rar",
  "audio/mpeg",
  "audio/midi audio/x-midi",
  "application/x-7z-compressed",
  "font/woff",
  "font/woff2",
  "audio/webm",
  "audio/wav",
  "font/ttf",
  "font/otf",
  "audio/aac"
];

export const noColor = {
  valueHexadecimale: "",
  rgba: ""
};

export const Evaluation_Format_Parent = {
  NOTE_SIMPLE: "Note simple",
  NIVEAU_DE_COMPETENCE: "Niveau de competence",
  LIKERT_AGREEMENT: "Echelle de Likert - En accord",
  LIKERT_SATISFACTION: "Echelle de Likert - Satisfaction",
  LIKERT_RELEVANCE: "Echelle de Likert - Pertinence",
  LIKERT_LIKELIHOOD: "Echelle de Likert - Probabilité",
  LIKERT_PERFORMANCE: "Echelle de Likert - Performance",
  LIKERT_EXPECTATIONS: "Echelle de Likert - Attentes",
  MENTAL_HEALTH_CONTINUUM: "Format spécial - Continium de la santé mentale"
};

export const Evaluation_Format_Tooltip = {
  // EN ACCORD
  note_likert_agree_4: "en accord sur 4",
  note_likert_agree_5: "en accord sur 5",
  note_likert_agree_6: "en accord sur 6",
  note_likert_agree_7: "en accord sur 7",

  // SATISFACTION
  note_likert_satisfaction_4: "satisfaction 4",
  note_likert_satisfaction_5: "satisfaction 5",
  note_likert_satisfaction_6: "satisfaction 6",
  note_likert_satisfaction_7: "satisfaction 7",

  // PERTINENCE
  note_likert_pertinence_4: "pertinence 4",
  note_likert_pertinence_5: "pertinence 5",

  // PROBABILITY
  note_likert_proba_4: "probability 4",
  note_likert_proba_5: "probability 5",

  // PERFORMANCE
  note_likert_perf_4: "performance 4",
  note_likert_perf_5: "performance 5",

  // StandBy
  note_likert_standBy_4: "standby 4",
  note_likert_standBy_5: "standby 5",

  // MENTAL HEALTH
  note_mental_health_4: "mental 4"
};

export const Evaluation_Format = {
  // NOTE SIMPLE
  NOTE_SUR_2: {
    name: "Sur 2",
    value: "Note sur 2",
    description: "Note simple sur 2",
    parent: Evaluation_Format_Parent.NOTE_SIMPLE,
    maxNote: 2
  },
  NOTE_SUR_4: {
    name: "Sur 4",
    value: "Note sur 4",
    description: "Note simple sur 4",
    parent: Evaluation_Format_Parent.NOTE_SIMPLE,
    maxNote: 4
  },
  NOTE_SUR_5: {
    name: "Sur 5",
    value: "Note sur 5",
    description: "Note simple sur 5",
    parent: Evaluation_Format_Parent.NOTE_SIMPLE,
    maxNote: 5
  },
  NOTE_SUR_6: {
    name: "Sur 6",
    value: "Note sur 6",
    description: "Note simple sur 6",
    parent: Evaluation_Format_Parent.NOTE_SIMPLE,
    maxNote: 6
  },
  NOTE_SUR_10: {
    name: "Sur 10",
    value: "Note sur 10",
    description: "Note simple sur 10",
    parent: Evaluation_Format_Parent.NOTE_SIMPLE,
    maxNote: 10
  },

  // NIVEAU DE COMPETENCE
  NIVEAU_DE_COMPETENCE_SUR_5: {
    name: "Sur 5",
    value: "Niveau de compétence sur 5",
    description: "Niveau de compétence sur 5",
    parent: Evaluation_Format_Parent.NIVEAU_DE_COMPETENCE,
    maxNote: 5
  },
  NIVEAU_DE_COMPETENCE_SUR_10: {
    name: "Sur 10",
    value: "Niveau de compétence sur 10",
    description: "Niveau de compétence sur 10",
    parent: Evaluation_Format_Parent.NIVEAU_DE_COMPETENCE,
    maxNote: 10
  },

  NOTE_DE_PERCENT: {
    name: "Note en pourcentage",
    value: "Note de %",
    description: "Note en pourcentage",
    maxNote: 100
  },
  NOTE_SUR_3_ETOILES: {
    name: "Note sur 3 étoiles",
    value: "Note sur 3 étoiles",
    description: "Note sur 3 étoiles",
    maxNote: 3
  },
  AFFIRMATION_OUI_NON: {
    name: "Affirmation - oui/non",
    value: "Affirmation - oui/non",
    description: "Affirmation - oui/non",
    displayedMaxNote: 2,
    maxNote: 7
  },

  // QUESTION SANS NOTE
  QUESTION: {
    name: "Question sans note",
    value: "Question sans note",
    description: "Question sans note",
    maxNote: 1
  },

  // LIKERT - AGREEMENT
  LIKERT_AGREEMENT_SUR_4: {
    name: "Sur 4",
    value: "Likert Agreement sur 4",
    description: Evaluation_Format_Tooltip.note_likert_agree_4,
    parent: Evaluation_Format_Parent.LIKERT_AGREEMENT,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_AGREEMENT_SUR_5: {
    name: "Sur 5",
    value: "Likert Agreement sur 5",
    description: Evaluation_Format_Tooltip.note_likert_agree_5,
    parent: Evaluation_Format_Parent.LIKERT_AGREEMENT,
    displayedMaxNote: 5,
    maxNote: 7
  },
  LIKERT_AGREEMENT_SUR_6: {
    name: "Sur 6",
    value: "Likert Agreement sur 6",
    description: Evaluation_Format_Tooltip.note_likert_agree_6,
    parent: Evaluation_Format_Parent.LIKERT_AGREEMENT,
    displayedMaxNote: 6,
    maxNote: 7
  },
  LIKERT_AGREEMENT_SUR_7: {
    name: "Sur 7",
    value: "Likert Agreement sur 7",
    description: Evaluation_Format_Tooltip.note_likert_agree_7,
    parent: Evaluation_Format_Parent.LIKERT_AGREEMENT,
    displayedMaxNote: 7,
    maxNote: 7
  },

  // LIKERT - SATISFACTION
  LIKERT_SATISFACTION_SUR_4: {
    name: "Sur 4",
    value: "Likert Satisfaction sur 4",
    description: Evaluation_Format_Tooltip.note_likert_satisfaction_4,
    parent: Evaluation_Format_Parent.LIKERT_SATISFACTION,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_SATISFACTION_SUR_5: {
    name: "Sur 5",
    value: "Likert Satisfaction sur 5",
    description: Evaluation_Format_Tooltip.note_likert_satisfaction_5,
    parent: Evaluation_Format_Parent.LIKERT_SATISFACTION,
    displayedMaxNote: 5,
    maxNote: 7
  },
  LIKERT_SATISFACTION_SUR_6: {
    name: "Sur 6",
    value: "Likert Satisfaction sur 6",
    description: Evaluation_Format_Tooltip.note_likert_satisfaction_6,
    parent: Evaluation_Format_Parent.LIKERT_SATISFACTION,
    displayedMaxNote: 6,
    maxNote: 7
  },
  LIKERT_SATISFACTION_SUR_7: {
    name: "Sur 7",
    value: "Likert Satisfaction sur 7",
    description: Evaluation_Format_Tooltip.note_likert_satisfaction_7,
    parent: Evaluation_Format_Parent.LIKERT_SATISFACTION,
    displayedMaxNote: 7,
    maxNote: 7
  },

  // LIKERT - RELEVANCE
  LIKERT_RELEVANCE_SUR_4: {
    name: "Sur 4",
    value: "Likert Relevance sur 4",
    description: Evaluation_Format_Tooltip.note_likert_pertinence_4,
    parent: Evaluation_Format_Parent.LIKERT_RELEVANCE,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_RELEVANCE_SUR_5: {
    name: "Sur 5",
    value: "Likert Relevance sur 5",
    description: Evaluation_Format_Tooltip.note_likert_pertinence_5,
    parent: Evaluation_Format_Parent.LIKERT_RELEVANCE,
    displayedMaxNote: 5,
    maxNote: 7
  },

  // LIKERT - LIKELIHOOD
  LIKERT_LIKELIHOOD_SUR_4: {
    name: "Sur 4",
    value: "Likert Likelihood sur 4",
    description: Evaluation_Format_Tooltip.note_likert_proba_4,
    parent: Evaluation_Format_Parent.LIKERT_LIKELIHOOD,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_LIKELIHOOD_SUR_5: {
    name: "Sur 5",
    value: "Likert Likelihood sur 5",
    description: Evaluation_Format_Tooltip.note_likert_proba_5,
    parent: Evaluation_Format_Parent.LIKERT_LIKELIHOOD,
    displayedMaxNote: 5,
    maxNote: 7
  },

  // LIKERT - PERFORMANCE
  LIKERT_PERFORMANCE_SUR_4: {
    name: "Sur 4",
    value: "Likert Performance sur 4",
    description: Evaluation_Format_Tooltip.note_likert_perf_4,
    parent: Evaluation_Format_Parent.LIKERT_PERFORMANCE,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_PERFORMANCE_SUR_5: {
    name: "Sur 5",
    value: "Likert Performance sur 5",
    description: Evaluation_Format_Tooltip.note_likert_perf_5,
    parent: Evaluation_Format_Parent.LIKERT_PERFORMANCE,
    displayedMaxNote: 5,
    maxNote: 7
  },

  // LIKERT - EXPECTATIONS
  LIKERT_EXPECTATIONS_SUR_4: {
    name: "Sur 4",
    value: "Likert Expectations sur 4",
    description: Evaluation_Format_Tooltip.note_likert_standBy_4,
    parent: Evaluation_Format_Parent.LIKERT_EXPECTATIONS,
    displayedMaxNote: 4,
    maxNote: 7
  },
  LIKERT_EXPECTATIONS_SUR_5: {
    name: "Sur 5",
    value: "Likert Expectations sur 5",
    description: Evaluation_Format_Tooltip.note_likert_standBy_5,
    parent: Evaluation_Format_Parent.LIKERT_EXPECTATIONS,
    displayedMaxNote: 5,
    maxNote: 7
  },

  // MENTAL HEALTH
  MENTAL_HEALTH_SUR_4: {
    name: "Sur 4",
    value: "Mental health sur 4",
    description: Evaluation_Format_Tooltip.note_mental_health_4,
    parent: Evaluation_Format_Parent.MENTAL_HEALTH_CONTINUUM,
    displayedMaxNote: 4,
    maxNote: 7
  }
};

export const Evaluation_Type = {
  COMPETENCE: "Compétence",
  PERFORMANCE: "Performance"
};

export const Evaluation_Request_Status = {
  TO_DO: "A faire",
  IN_PROGRESS: "En cours",
  DONE: "Terminées"
};

export const Evaluation_noteStatus = {
  BEGINER: 0,
  JUNIOR: 20,
  INTERMEDIARY: 50,
  EXPERIENCED: 80
};

export const EvaluationStatus = {
  BEGINER: "En formation",
  JUNIOR: "Junior",
  INTERMEDIARY: "Intermédiaire",
  EXPERIENCED: "Expérimenté"
};

export const IndividualObjectiveScoreType = {
  RATING_4: "Note sur 4",
  RATING_5: "Note sur 5",
  RATING_10: "Note sur 10",
  RATING_100: "Note sur 100",
  RATING_3_STARS: "Note sur 3 étoiles",
  NOT_APPLICABLE: "N/A"
};

export const ERROR_UPLOAD_FILES = [
  "rejected_file_type",
  "rejected_max_files",
  "error_file_size",
  "error_validation",
  "error_upload_params",
  "exception_upload",
  "error_upload"
];

export const PatternLinkedin =
  /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|company|pub|profile)\/([A-z0-9_-]+\/?)+$/;

export const MODE = [
  {
    _id: "walking",
    label: "Péages",
    value: "WALKING"
  },
  {
    _id: "driving",
    label: "Autoroutes",
    value: "DRIVING"
  },
  {
    _id: "transit",
    label: "Traversiers",
    value: "TRANSIT"
  }
];

export const OPTIONS_GEOLOCALISATION = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};

export const DEFAULT_COLUMNS_SELECTED_ON_BANK_CV = [
  {
    _id: 0,
    name: "Nom du candidat",
    value: "firstnameFirstFilter"
  },
  {
    _id: 1,
    name: "Poste appliqué",
    value: "job.title"
  },
  {
    _id: 2,
    name: "Commentaires",
    value: "noteCommentaire"
  },
  {
    _id: 3,
    name: "Expériences",
    value: "noteExperience"
  },
  {
    _id: 4,
    name: "Compétences",
    value: "noteCompetence"
  },
  {
    _id: 5,
    name: "Éducations",
    value: "noteEducation"
  },
  {
    _id: 6,
    name: "Contenu du CV",
    value: "CV.extractCV"
  }
];

export const EMPLOYE_FILE_SECTIONS = [
  {
    _id: "DListInfopers",
    name: "Informations personnelles/Informations"
  },
  {
    _id: "DListInfopersSectionEmailsAndPhones",
    name: "Informations personnelles/Courriels et téléphones"
  },
  {
    _id: "DListInfopersSectionAdress",
    name: "Informations personnelles/Adresse"
  },
  {
    _id: "DListInfopersSectionHealthAndFoods",
    name: "Informations personnelles/Santé - Allergies et préférences alimentaires"
  },
  {
    _id: "DListInfopersSectionClothingSizes",
    name: "Informations personnelles/Taille des vêtements"
  },
  {
    _id: "DListInfopersSectionFirstEmergencyContact",
    name: "Informations personnelles/Premier Contact d'urgence"
  },
  {
    _id: "DListInfopersSectionSecondEmergencyContact",
    name: "Informations personnelles/Deuxième Contact d'urgence"
  },
  {
    _id: "DListInfopersSectionAdditionalInformation",
    name: "Informations personnelles/Informations complémentaires"
  },
  {
    _id: "DListEmploisalarySectionJob",
    name: "Emploi, salaire et vacances/Emploi"
  },
  {
    _id: "DListEmploisalarySectionBankingAndInsuranceInformation",
    name: "Emploi, salaire et vacances/Informations bancaires et d'assurance"
  },
  {
    _id: "DListEmploisalarySectionUnavailabilityPeriodsHealthAndSecurity",
    name: "Emploi, salaire et vacances/Périodes d'indisponibilités, santé et sécurité"
  },
  {
    _id: "DListEmploisalarySectionDisciplinaryTracking",
    name: "Emploi, salaire et vacances/Suivi disciplinaire"
  },
  {
    _id: "DListEmploisalarySectionDeparture",
    name: "Emploi, salaire et vacances/Départ"
  },
  {
    _id: "DListEmploisalarySectionSalaryAndAdvantages",
    name: "Emploi, salaire et vacances/Parcours professionnel, salaire et avantages"
  },
  {
    _id: "DListEmploisalarySectionHolidays",
    name: "Emploi, salaire et vacances/Vacances"
  },
  {
    _id: "DListDocumentNoteSectionDocuments",
    name: "Documents et notes/Documents"
  },
  {
    _id: "DListDocumentNoteSectionDocumentsRH",
    name: "Documents et notes/Documents RH"
  },
  {
    _id: "DListDocumentNoteSectionNotes",
    name: "Documents et notes/Notes"
  },
  {
    _id: "DListDocumentNoteSectionNotesRH",
    name: "Documents et notes/Notes RH"
  },
  {
    _id: "DListCertFormationSectionLicensesAndCertifications",
    name: "Permis et formations/Permis et Certifications"
  },
  {
    _id: "DListCertFormationSectionFormations",
    name: "Permis et formations/Formations"
  },
  {
    _id: "assignedMaterial",
    name: "Matériel assigné"
  },
  {
    _id: "accountSetting",
    name: "Paramètres du compte"
  }
];

export const UPLOAD_LIMIT = 30;

export const ACCESS_LIST_KEYS = {
  canAddFileOnMyProfile: "canAddFileOnMyProfile",
  canAccessLegalGender: "canAccessLegalGender",
  canAccessDateOfBirth: "canAccessDateOfBirth",
  canAccessOriginCountry: "canAccessOriginCountry",
  canAccessLanguagesSpoken: "canAccessLanguagesSpoken",
  canAccessEmails: "canAccessEmails",
  canAccessPhones: "canAccessPhones",
  canAccessAddress: "canAccessAddress",
  canAccessHealthAllergiesFoodPrefs: "canAccessHealthAllergiesFoodPrefs",
  canAccessClothingSize: "canAccessClothingSize",
  canAccessFirstContact: "canAccessFirstContact",
  canAccessSecondContact: "canAccessSecondContact",
  canAccessCertsLicenses: "canAccessCertsLicenses",
  canAccessInsuranceSocialNumber: "canAccessInsuranceSocialNumber",
  canAccessBankingInformation: "canAccessBankingInformation",
  denyLoginPasswordAccess: "denyLoginPasswordAccess",
  acceptOwnVacanyRequestEnterprise: "acceptOwnVacanyRequestEnterprise",
  updateOwnDevelopmentPlanEmployee: "updateOwnDevelopmentPlanEmployee",
  denyAccessOwnFolderEnterprise: "denyAccessOwnFolderEnterprise",
  isActiveBankingInformationAndInsuranceAccess:
    "isActiveBankingInformationAndInsuranceAccess",
  canVisibleYearOfBirth: "canVisibleYearOfBirth",
  canSeeNethrisConnection: "canSeeNethrisConnection",
  canAccessAdditionalInformation: "canAccessAdditionalInformation",
  canCreateImportEmployees: "canCreateImportEmployees",
  canToggleAlteeAccess: "canToggleAlteeAccess",
  canModifyTraining: "canModifyTraining",
  canModifyCertification: "canModifyCertification",
  canModifyEvaluationResults: "canModifyEvaluationResults"
};

export const EXPORT_TYPES = [
  { name: "Informations des employés", _id: "denyExportEmployeeInfo" },
  { name: "Remboursements", _id: "denyExportReimbursements" },
  { name: "Formations", _id: "denyExportTraining" },
  { name: "Heures travaillés - récapitulatifs", _id: "denyExportHoursSummary" },
  {
    name: "Heures travaillés - répartitions par projets",
    _id: "denyExportHoursByProject"
  },
  { name: "Banques de CVs - Candidats", _id: "denyExportCvBanks" },
  { name: "Certifications", _id: "denyExportCertification" },
  { name: "Vacances et absences", _id: "denyExportHolidaysAndAbsences" }
];

export const AUTO_DECONNECT_OPTIONS = [
  { name: "4h", _id: "4h" },
  { name: "8h", _id: "8h" },
  { name: "12h", _id: "12h" },
  { name: "24h", _id: "24h" },
  { name: "48h", _id: "48h" },
  { name: "72h", _id: "72h" },
  { name: "Illimité", _id: "illimited" },
  { name: "Synchronisé avec le SSO", _id: "sso" }
];

export const COLORS = {
  Absence: {
    backgroundColor: "arh-bg-[#FBEED6]",
    borderColor: "arh-border-[#FBEED6]",
    textColor: "arh-text-[#F29D0E]",
    dotColor: "arh-bg-[#F29D0E]"
  },
  Vacances: {
    backgroundColor: "arh-bg-[#E2F1FE]",
    borderColor: "arh-border-[#E2F1FE]",
    textColor: "arh-text-[#265985]",
    dotColor: "arh-bg-[#265985]"
  },
  Maladie: {
    backgroundColor: "arh-bg-[#F9E6DD]",
    borderColor: "arh-border-[#F9E6DD]",
    textColor: "arh-text-[#C24E27]",
    dotColor: "arh-bg-[#C24E27]"
  },
  TimeBank: {
    backgroundColor: "arh-bg-[#ffc9c9]",
    borderColor: "arh-border-[#ffc9c9]",
    textColor: "arh-text-[#750000]",
    dotColor: "arh-bg-[#750000]"
  }
};

export const OTHER_COLOR = {
  backgroundColor: "arh-bg-green-200",
  borderColor: "arh-border-green-200",
  textColor: "arh-text-black",
  dotColor: "arh-bg-green-700"
};

export const NETHRIS_COLOR = {
  backgroundColor: "arh-bg-gray-200",
  borderColor: "arh-border-gray-200",
  textColor: "arh-text-black",
  dotColor: "arh-bg-gray-700"
};

export const UNAVAILABILITY_COLOR = [
  "#9F75FF",
  "#ED6D85",
  "#cbe7e7",
  "#E58C40",
  "#FEE19D",
  "#A2A6AE",
  "#FDB0C0",
  "#37A1EB",
  "#FE6383",
  "#F8FAA3",
  "#4A8458",
  "#DDC7FF",
  "#C8C2EF",
  "#C11574",
  "#FDF2FA",
  "#F5DAFE",
  "#973EAD",
  "#CAEBCD",
  "#BAD8E5",
  "#34A490",
  "#FCF4AC",
  "#504EBB",
  "#E6FFE1",
  "#E6C9E7",
  "#D01212",
  "#49A536"
];
export const NOT_INFORMED = "Non renseigné";
export const COLOR_NO_INFORMATION = "#47B5B3";

export const SECTION_BULK_CONFIG = {
  personalInfos: {
    name: "Informations Personnelles",
    _id: "personalInfos",
    permission: "DListInfopers",
    batchPermission: "denyPersonalInfos"
  },
  emailsAndPhones: {
    name: "Courriels et téléphones",
    _id: "emailsAndPhones",
    permission: "DListInfopersSectionEmailsAndPhones",
    batchPermission: "denyEmailsAndPhones"
  },
  address: {
    name: "Adresse",
    _id: "address",
    permission: "DListInfopersSectionAdress",
    batchPermission: "denyAddress"
  },
  healthAllergiesFoodPrefs: {
    name: "Santé - Allergies et préférences alimentaires",
    _id: "healthAllergiesFoodPrefs",
    permission: "DListInfopersSectionHealthAndFoods",
    batchPermission: "denyHealthAllergiesFoodPrefs"
  },
  clothingSize: {
    name: "Taille des vêtements",
    _id: "clothingSize",
    permission: "DListInfopersSectionClothingSizes",
    batchPermission: "denyClothingSize"
  },
  firstContact: {
    name: "Premier contact d'urgence",
    _id: "firstContact",
    permission: "DListInfopersSectionFirstEmergencyContact",
    batchPermission: "denyFirstContact"
  },
  secondContact: {
    name: "Deuxième contact d'urgence",
    _id: "secondContact",
    permission: "DListInfopersSectionSecondEmergencyContact",
    batchPermission: "denySecondContact"
  },
  job: {
    name: "Emploi",
    _id: "job",
    permission: "DListEmploisalarySectionJob",
    batchPermission: "denyJob"
  },
  security: {
    name: "Sécurité",
    _id: "security",
    permission: "DListEmploisalarySectionJob",
    batchPermission: "denySecurity"
  },
  departure: {
    name: "Départ",
    _id: "departure",
    permission: "DListEmploisalarySectionDeparture",
    batchPermission: "denyDeparture"
  },
  bankingAndInsuranceInformation: {
    name: "Information bancaire et d'assurance",
    _id: "bankingAndInsuranceInformation",
    permission: "DListEmploisalarySectionBankingAndInsuranceInformation",
    batchPermission: "denyBankingAndInsuranceInformation"
  },
  salaryAndAdvantages: {
    name: "Parcours professionnel et salaires",
    _id: "salaryAndAdvantages",
    permission: "DListEmploisalarySectionSalaryAndAdvantages",
    batchPermission: "denySalaryAndAdvantages"
  },
  hoursPerDayAndBalance: {
    name: "Droits annuels, soldes actuels et heures travaillées par jour",
    _id: "hoursPerDayAndBalance",
    permission: "DListEmploisalarySectionHolidays",
    batchPermission: "denyHoursPerDayAndBalance"
  },
  additionalInformation: {
    name: "Informations complémentaires",
    _id: "additionalInformation",
    permission: "DListInfopersSectionAdditionalInformation",
    batchPermission: "denyAdditionalInformation"
  }
};
export const defaultDocuments = [
  {
    value: "Documents",
    label: "Documents",
    key: "Documents/",
    docType: "document",
    children: []
  }
];
export const defaultDocumentsRH = [
  {
    value: "DocumentsRH",
    label: "Documents RH",
    key: "DocumentsRH/",
    docType: "documentRH",
    children: []
  }
];
export const flagTypeOptions = [
  {
    id: "delay",
    label: "Retard",
    value: "delay"
  },
  {
    id: "timeDifference",
    label: "Différence avec l'horaire",
    value: "timeDifference"
  },
  {
    id: "hoursBetween",
    label: "Heures comprises entre",
    value: "hoursBetween"
  },
  {
    id: "overtime",
    label: "Dépassement des heures",
    value: "overtime"
  },
  {
    id: "missingHourType",
    label: "Type d'heure manquant",
    value: "missingHourType"
  },
  {
    id: "selectedHourType",
    label: "Type d'heure spécifique selectionné",
    value: "selectedHourType"
  },
  {
    id: "missingAssignment",
    label: "Assignation/Projet manquant",
    value: "missingAssignment"
  },
  {
    id: "selectedAssignment",
    label: "Assignation/Projet sélectionné",
    value: "selectedAssignment"
  }
];

export const checkBoxVariantsColor = {
  green: "checked:before:arh-bg-greenColor",
  orange: "checked:before:arh-bg-orangeColor",
  blue: "checked:before:arh-bg-blueColor",
  gray: "checked:before:arh-bg-gray-500",
  babyBlue: "checked:before:arh-bg-[#95C5E7]"
};

export const ANONYMOUS_SURVEY_AVATAR_COLORS = [
  { background: "#FFC27D", foreground: "#A62100" },
  { background: "#FF9DBB", foreground: "#85002B" },
  { background: "#E3C6FF", foreground: "#472283" },
  { background: "#80C9FF", foreground: "#003A91" },
  { background: "#8CF5D7", foreground: "#006D61" },
  { background: "#FFE681", foreground: "#A95A00" },
  { background: "#B7F777", foreground: "#267000" },
  { background: "#FF8C87", foreground: "#A00000" }
];
